var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#6B7280;stroke-miterlimit:10;stroke-width:1.88px;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.12,22.31l-5-5a2,2,0,0,1-.58-1.41,2,2,0,0,1,.58-1.4,2,2,0,0,1,1.41-.59,2,2,0,0,1,1.4.59l1.3,1.29V6.48a1.94,1.94,0,0,1,1.71-2,1.89,1.89,0,0,1,2,1.86V12l5,.71a1.87,1.87,0,0,1,1.61,1.85h0a16.9,16.9,0,0,1-1.79,7.58l-.09.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.94,10.67a4.55,4.55,0,0,0,1.44-1,4.69,4.69,0,1,0-6.64,0,4.59,4.59,0,0,0,1.45,1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickAction);
export default __webpack_public_path__ + "static/media/quick-action.54a7582eb1a6e40d63031bf11b4b01ec.svg";
export { ForwardRef as ReactComponent };